import { gql } from "@apollo/client";

export default gql`
  mutation invalidateLiveChatWidgetCache{
    invalidateLiveChatWidgetCache{
        success
        data{
            id
            status
            createTime
        }
        error
        message
    }
}
`
